export default __webpack_public_path__ + "static/media/Banner-1.ebc57e0c.jpg";